/**
 * * Модель запрсоа на получение информации о доступах пользователя по taskId
 */
export class GetUserRoleByTaskIdsRequsetModel {
  /**
   * * Номера задач
   */
  TaskIds!: Array<number>;
  constructor(obj?: Partial<GetUserRoleByTaskIdsRequsetModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
